 <template>
    <div>
        <div class="one-toolbar"> 
            <span class="spanRow">
                <span style="margin-right:20px;font-size:14px;margin-left:2px;color:#fff;font-weight:600">提示：只引用审核的订单</span>
                <!-- <i class="iconfont icon-chenggong1" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:15px;"></i>
                <el-link   @click="selSure" :underline="false" ><span style="font-size:12px;margin-right:15px;">选择</span></el-link> -->
                <el-button type="primary" @click="selSure" icon="iconfont icon-chenggong1" size="mini"  >确定</el-button>
                <el-select v-model="selparam"  placeholder="请选择列名" clearable size="small" style="width:150px;line-height:40px;margin-left:15px">
                    <span v-for="item in tabArr.filter(item=>item.thide=='N')" :key='item.key'>
                        <el-option :label="item.title" :value="item.key" style="width:150px;"></el-option>
                    </span>
                </el-select>
                <el-input placeholder="请输入查询值" v-model="txtparam" @keyup.native.enter="qryTabData" size="small" style="width:380px; margin-top:4px; height:30px; ">
                    <el-button slot="append" size="small" icon="el-icon-search" @click="qryTabData" style="color:#409eff"></el-button>
                    <div slot="prepend">
                        <el-select v-model="oper" slot="prepend"   style="width:100px; " >
                            <span v-for="item in operArr" :key='item.IDSEQ'>
                                <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                            </span>
                        </el-select>
                    </div>
                </el-input>  
            </span>
        </div>
        <el-table  :data="tabData" 
                border                            
                disabled-hover
                style="overflow:auto;margin-top:1px;"
                size="small"
                :row-key="getRowKey"  
                :height="250"
                ref="tabref" 
                class="custom-table-border"
                @row-click="rowClick"
                highlight-current-row>
            <el-table-column label="序号" type="index" width="55"></el-table-column>
            <el-table-column  v-for="(item,index ) in tabArr.filter(item=>item.thide=='N')" :key="index" 
                :prop="item.key"
                :label="item.title"
                show-overflow-tooltip
                :align="item.align"                                  
                :sortable="item.sortable=='N'"
                :min-width="item.width">   
                <template  slot-scope="scope" >   
                    <el-checkbox disabled v-if="item.edcss=='checkbox'" v-model="scope.row[item.key]" true-label="Y" false-label="N"></el-checkbox>
                    <div v-else v-text="scope.row[item.key]" style="float:left"> </div>
                </template>
            </el-table-column> 
            <!-- <el-table-column  v-if="item.key==='STFG'"
                :prop="item.key"
                :label="item.title"
                show-overflow-tooltip
                :align="item.align"                                  
                :min-width="item.width">
                <template  slot-scope="scope" >
                    <i v-if="scope.row.STFG==='Y'" class="iconfont icon-xuanze" style="color:green"></i>
                </template>
            </el-table-column>  -->
        </el-table>        

        <el-table  :data="dtlData" 
            border                            
            size="small"
            ref="refdtl"
            class="custom-table-border"
            :height="tabHeight" 
            highlight-current-row> 
            <el-table-column 
                prop="SEL"
                label="选择"
                fixed="left"
                align="center"  >
                <template   slot-scope="scope" >
                    <el-checkbox  true-label="Y"  false-label="N" v-model="scope.row.SEL" ></el-checkbox>
                </template>
            </el-table-column> 
      
            <el-table-column    v-for="(item ) in dtlCol.filter(item=>item.thide=='N')" :key="item.key" 
                :prop="item.key"
                :label="item.title"
                show-overflow-tooltip
                :align="item.align"                                  
                sortable
                :min-width="item.width">
            </el-table-column> 
    
                                    
        </el-table> 
        <el-dialog :visible.sync="promptWin" width="450px" append-to-body :show-close="false">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">提示</span>
            </div> 
            <div style="line-height:30px;display:flex">
                <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
            </div>
            <span slot="footer"  >
                <el-button size="small" type="primary" @click="promptWin = false">确 定</el-button>
            </span>
        </el-dialog>
    </div>        
</template>
<script>
 
import { getTabColOrData,getBaseData } from '../../api/user';
import { getDate } from '../../api/Select' 
export default{
    props: {
 
        v_cond:{
            type: String,
            default:'',
        },
        v_random:{
            type: String,
            default:'',
        },
    },
    data () {
        return {
            selparam:'IDNO',
            txtparam:'',
            oper:'like',
            tabArr:[],
            tabData:[],
            dtlData:[],
            dtlCol:[],
            v_url:'xuper_auth/getTableRecMany' , //api请求路径
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') , //账套ID
            operArr:[],
            promptWin:false,
            prompt:'',
        }
    },
    created () {
        //查询表字段列和表数据
        this.getOrdList('')
        this.getTabField()  
    },
    computed:{
 
        tabHeight: function() {
            return (window.innerHeight - 420) + 'px';
        }, 
    },
    mounted () {
        //操作符
        getBaseData(this.v_url,'PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        })
    },
    methods: {
        qryTabData(){
            let cond_=''
            if (this.selparam){ //列1
                if (this.oper==='like'){
                    cond_=cond_+' and  '+this.selparam+'  like  \'%' + this.txtparam+'%\' '
                }else{
                    cond_=cond_+' and  '+this.selparam  +this.oper+' \''+this.txtparam+'\' '
                }
            }
 
            this.getOrdList(cond_+v_cond)
        },
        getRowKey(row){
            return row.IDSEQ
        },
        //选择确认
        selSure(){
            if (this.dtlData.filter(item=>item.SEL=='Y').length==0){
                this.promptWin =true
                this.prompt ='请选择记录'
            }else{
                let data_=[]
                for(let k=0;k<this.dtlData.length;k++){
                    if(this.dtlData[k].SEL==='Y'){
                        data_.push(this.dtlData[k])
                    }
                }
                this.$emit('child-sure',data_)
            }
        },
        rowClick(row){
            this.getDtlData(row.IDSEQ)
        },
        //查询明细数据
        getDtlData(idseq){
            getTabColOrData(this.v_url,'V_orditm','idseq',idseq).then((res) => {
                this.dtlData=[]
                this.dtlData =res.result 
                this.$nextTick(()=>{
                    this.$refs['refdtl'].doLayout()
                }) 
            })
        },
        //订单明细
        getOrdList(cond){
            //获取所有产品记录且初始化分页记录         
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'stfg', p_value:'Y',p_key2:'corpid', p_value2:this.v_corpid,p_cond:cond,p_table:'V_ord'},
            }).then(res=>{ 
                if (res.code==='200'){
                    this.tabData =res.result
                    if (res.result.length>0){
                        this.getDtlData(res.result[0].IDSEQ)
                        this.$refs['tabref'].setCurrentRow(res.result[0])
                    }else{
                        this.dtlData=[]
                    }
                }else{
                    this.promtWin=true
                    this.prompt=res.result
                }
            }) 
        },
        //获取表列字段
        getTabField(){
            let vm =this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','123','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.tabArr.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss: res.result[k].EDCSS,
                        thide:res.result[k].THIDE,
                        holder:res.result[k].HOLDER,
                        fhide:res.result[k].FHIDE,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                        sortable:res.result[k].SORTABLE,
                    })
                }
            }),
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','123','lstseq','2','','',' order by sortby,itmseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.dtlCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                    })
                }
            })
        }
    }
} 
</script>
<style scoped lang="less">
 
    .headbar{
        padding-left:5px; 
        line-height:40px;
        background:#fff;
        overflow: auto;
        padding-top:2px;
        display:flex;
        border-left:2px solid #409eff;
    }
 
 
 .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 1px auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
    .item-width  {
        width: 48%;
        color:#409EFF;
    }
 
</style>
<style lang="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px !important;
            color:rgb(128,128, 128);
            font-size:12px;
        }
        td {
            padding: 5px ;
            font-size:11px;
        }   
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
 